import { render, staticRenderFns } from "./ImsGroupTable.vue?vue&type=template&id=141951ad&scoped=true&"
import script from "./ImsGroupTable.vue?vue&type=script&lang=js&"
export * from "./ImsGroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141951ad",
  null
  
)

export default component.exports